import { stores } from '@kurtosys/app-start';
import { components } from '@kurtosys/ksys-app-components';
import { common } from '@kurtosys/ksys-app-template';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { action, computed, makeObservable } from 'mobx';

import { IComponentStyles } from '../../../models/app/IComponentStyles';
import { IConfiguration } from '../../../models/app/IConfiguration';
import { TStoreContext } from '../../../models/app/TStoreContext';
import { AppStore } from '../../App/stores/AppStore.js';
import { IAsOfDateConfiguration } from '../models';
type IAsOfDateProps = components.base.AsOfDate.models.IAsOfDateProps;

const {
	isNullOrEmpty,
	isNullOrUndefined,
	isArrayLike,
	sortBy,
	deepMergeObjectsWithOptions,
	pivotCollection,
	deepMergeObjects,
} = common.commonUtils;

const StoreBase = stores.base.StoreBase<IConfiguration, IComponentStyles>;

export class AsOfDateStore extends StoreBase {
	static componentKey = 'asOfDate' as const;

	appStore: AppStore;

	constructor(storeContext: TStoreContext, manifest: IManifest) {
		super(storeContext, manifest);
		this.appStore = this.storeContext.get<AppStore>('appStore');

		makeObservable(this);
	}

	@computed
	get configuration(): IAsOfDateConfiguration | undefined {
		if (this.appStore) {
			return this.appStore.getComponentConfiguration(AsOfDateStore.componentKey);
		}
	}

	@action
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	async initialize(): Promise<void> {}

	@computed
	get asOfDateProps(): IAsOfDateProps | undefined {
		const asOfDateProps = this.configuration;
		if (asOfDateProps) {
			return {
				title: asOfDateProps.title,
				text: asOfDateProps.text,
				date: this.getQueryValue(asOfDateProps.date),
			};
		}
	}
}
